import { SelectOption } from 'components/UI/V3/Forms/Select';

/**
 * Organization Access Levels
 */

/**
 * Roles assignable from the organization portal.
 *
 * Staff is deliberately absent: marketplace staff are created through the
 * staffs endpoint and linked to a marketplace, and organization_managers
 * rejects an access_level_id of 3.
 */
export const ORG_ROLE_OPTIONS: Array<SelectOption<{ id: number; name: string }>> = [
    { label: 'Admin', value: '1', data: { id: 1, name: 'Admin' } },
    { label: 'Manager', value: '2', data: { id: 2, name: 'Manager' } }
];

/**
 * Labels for every role a member may carry, including roles that cannot be
 * assigned from here. Display vocabulary is wider than the selectable set, so
 * an unassignable role still renders legibly rather than as "Unknown".
 */
export const ROLE_LABELS: Readonly<Record<number, string>> = {
    1: 'Admin',
    2: 'Manager',
    3: 'Staff'
};

/**
 * User Pagination
 */
export interface UserPagination {
    currentPage: number;
    nextPage: number | null;
    prevPage: number | null;
    size: number;
    totalPages: number;
    totalRecords: number;
}

export interface User {
    id: number;
    orgAccessLevelId: number;
    firstName: string;
    lastName: string;
    email: string;
    password: string;
    passwordConfirmation: string;
    phone: string;
    emailOptout: boolean;
    admin: boolean;
    active: boolean;
    marketplaceId?: number;
}

export interface SaveUser {
    user: {
        id?: number;
        orgAccessLevelId: number;
        firstName: string;
        lastName: string;
        email: string;
        password: string;
        passwordConfirmation: string;
        phone: string;
        emailOptout: boolean;
        admin: boolean;
        active: boolean;
        marketplace_id?: number | null;
    };
}
